'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withReduxForm = require('../../libs/hocs/withReduxForm');

var _withReduxForm2 = _interopRequireDefault(_withReduxForm);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

var _constants = require('../../libs/constants');

var _context = require('./context');

var _menuContent = require('./menuContent');

var _menuContent2 = _interopRequireDefault(_menuContent);

var _utils = require('./utils');

var _label = require('./label');

var _label2 = _interopRequireDefault(_label);

require('./styles.css');

var _utils2 = require('../../libs/utils');

var _menuArrowButton = require('./menuArrowButton');

var _menuArrowButton2 = _interopRequireDefault(_menuArrowButton);

var _getNormalizeValue4 = require('./helpers/getNormalizeValue');

var _getNormalizeValue5 = _interopRequireDefault(_getNormalizeValue4);

var _isChildRegistered = require('./helpers/isChildRegistered');

var _isChildRegistered2 = _interopRequireDefault(_isChildRegistered);

var _isOptionVisible = require('./helpers/isOptionVisible');

var _isOptionVisible2 = _interopRequireDefault(_isOptionVisible);

var _shouldOpenMenu = require('./helpers/shouldOpenMenu');

var _shouldOpenMenu2 = _interopRequireDefault(_shouldOpenMenu);

var _calculateScrollOffset = require('./helpers/calculateScrollOffset');

var _calculateScrollOffset2 = _interopRequireDefault(_calculateScrollOffset);

var _isScrollPositionAtMenuBottom = require('./helpers/isScrollPositionAtMenuBottom');

var _isScrollPositionAtMenuBottom2 = _interopRequireDefault(_isScrollPositionAtMenuBottom);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toArray(arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var sizeMap = {
  medium: 227
};
/**
 * A Picklist provides a user with an read-only input field that is accompanied with
 *  a listbox of pre-defined options.
 * @category Form
 */

var Picklist = function (_Component) {
  _inherits(Picklist, _Component);

  function Picklist(props) {
    var _this$keyHandlerMap;

    _classCallCheck(this, Picklist);

    var _this = _possibleConstructorReturn(this, (Picklist.__proto__ || Object.getPrototypeOf(Picklist)).call(this, props));

    _this.inputId = (0, _utils2.uniqueId)('picklist-input');
    _this.errorMessageId = (0, _utils2.uniqueId)('error-message');
    _this.containerRef = _react2["default"].createRef();
    _this.triggerRef = _react2["default"].createRef();
    _this.menuRef = _react2["default"].createRef();
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleKeyPressed = _this.handleKeyPressed.bind(_this);
    _this.hoverChild = _this.hoverChild.bind(_this);
    _this.handleOptionClick = _this.handleOptionClick.bind(_this);
    _this.handleScrollUpArrowHover = _this.handleScrollUpArrowHover.bind(_this);
    _this.handleScrollDownArrowHover = _this.handleScrollDownArrowHover.bind(_this);
    _this.updateScrollingArrows = _this.updateScrollingArrows.bind(_this);
    _this.stopArrowScoll = _this.stopArrowScoll.bind(_this);
    _this.registerChild = _this.registerChild.bind(_this);
    _this.unregisterChild = _this.unregisterChild.bind(_this);
    _this.activeChildren = [];
    _this.state = {
      isOpen: false,
      activeOptionIndex: -1,
      activeOptionName: null,
      showScrollUpArrow: undefined,
      showScrollDownArrow: undefined
    };
    _this.keyHandlerMap = (_this$keyHandlerMap = {}, _defineProperty(_this$keyHandlerMap, _constants.UP_KEY, _this.handleKeyUpPressed.bind(_this)), _defineProperty(_this$keyHandlerMap, _constants.DOWN_KEY, _this.handleKeyDownPressed.bind(_this)), _defineProperty(_this$keyHandlerMap, _constants.ESCAPE_KEY, _this.closeMenu.bind(_this)), _defineProperty(_this$keyHandlerMap, _constants.TAB_KEY, _this.closeMenu.bind(_this)), _defineProperty(_this$keyHandlerMap, _constants.ENTER_KEY, _this.handleKeyEnterPressed.bind(_this)), _this$keyHandlerMap);
    return _this;
  }

  _createClass(Picklist, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var wasOpen = prevState.isOpen;
      var isOpen = this.state.isOpen;

      if (!wasOpen && isOpen) {
        this.scrollTo(0);
        this.updateScrollingArrows();
      }
    }
  }, {
    key: 'getContainerClassNames',
    value: function getContainerClassNames() {
      var isOpen = this.state.isOpen;
      var _props = this.props,
          className = _props.className,
          readOnly = _props.readOnly,
          error = _props.error;
      return (0, _classnames2["default"])('rainbow-picklist', {
        'rainbow-picklist--error': error,
        'rainbow-picklist--readonly': readOnly,
        'rainbow-picklist--open': isOpen && !readOnly
      }, className);
    }
  }, {
    key: 'getContext',
    value: function getContext() {
      var activeOptionName = this.state.activeOptionName;
      var value = this.props.value;

      var _getNormalizeValue = (0, _getNormalizeValue5["default"])(value),
          name = _getNormalizeValue.name;

      return {
        privateOnClick: this.handleOptionClick,
        privateRegisterChild: this.registerChild,
        privateUnregisterChild: this.unregisterChild,
        privateOnHover: this.hoverChild,
        activeOptionName: activeOptionName,
        currentValueName: name
      };
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'getMenuMaxHeight',
    value: function getMenuMaxHeight() {
      return sizeMap.medium;
    }
  }, {
    key: 'getInputClassNames',
    value: function getInputClassNames() {
      var value = this.props.value;

      var _getNormalizeValue2 = (0, _getNormalizeValue5["default"])(value),
          icon = _getNormalizeValue2.icon;

      return (0, _classnames2["default"])('rainbow-picklist_input', {
        'rainbow-picklist_input--icon': !!icon
      });
    }
  }, {
    key: 'getIndicatorClassNames',
    value: function getIndicatorClassNames() {
      var disabled = this.props.disabled;
      return (0, _classnames2["default"])('rainbow-picklist_input-dropdown-indicator', {
        'rainbow-picklist_input-dropdown-indicator--disabled': disabled
      });
    }
  }, {
    key: 'getDropdownClassNames',
    value: function getDropdownClassNames() {
      var isLoading = this.props.isLoading;
      return (0, _classnames2["default"])('rainbow-picklist_dropdown', {
        'rainbow-picklist_dropdown--loading-box': isLoading
      });
    }
  }, {
    key: 'getErrorMessageId',
    value: function getErrorMessageId() {
      var error = this.props.error;

      if (error) {
        return this.errorMessageId;
      }

      return undefined;
    }
  }, {
    key: 'handleKeyUpPressed',
    value: function handleKeyUpPressed() {
      var activeOptionIndex = this.state.activeOptionIndex;
      var nextActiveIndex = (this.activeChildren.length + activeOptionIndex - 1) % this.activeChildren.length;

      if (nextActiveIndex < activeOptionIndex) {
        if (nextActiveIndex === 0) {
          this.scrollTo(0);
        } else {
          this.scrollToOption(nextActiveIndex);
        }

        this.setState({
          activeOptionIndex: nextActiveIndex,
          activeOptionName: this.activeChildren[nextActiveIndex].name
        });
      }
    }
  }, {
    key: 'handleKeyDownPressed',
    value: function handleKeyDownPressed() {
      var activeOptionIndex = this.state.activeOptionIndex;
      var nextActiveIndex = (activeOptionIndex + 1) % this.activeChildren.length;

      if (nextActiveIndex > 0) {
        this.scrollToOption(nextActiveIndex);
        this.setState({
          activeOptionIndex: nextActiveIndex,
          activeOptionName: this.activeChildren[nextActiveIndex].name
        });
      }
    }
  }, {
    key: 'handleKeyEnterPressed',
    value: function handleKeyEnterPressed() {
      var onChange = this.props.onChange;
      var activeOptionIndex = this.state.activeOptionIndex;
      var _activeChildren$activ = this.activeChildren[activeOptionIndex],
          label = _activeChildren$activ.label,
          name = _activeChildren$activ.name,
          icon = _activeChildren$activ.icon,
          value = _activeChildren$activ.value;
      this.closeMenu();
      return onChange({
        label: label,
        name: name,
        icon: icon,
        value: value
      });
    }
  }, {
    key: 'handleKeyPressed',
    value: function handleKeyPressed(event) {
      var isOpen = this.state.isOpen;

      if (isOpen) {
        if ([_constants.UP_KEY, _constants.DOWN_KEY, _constants.SPACE_KEY].includes(event.keyCode)) event.preventDefault();

        if (this.keyHandlerMap[event.keyCode]) {
          return this.keyHandlerMap[event.keyCode]();
        }
      } else if ((0, _shouldOpenMenu2["default"])(event.keyCode)) {
        event.preventDefault();
        this.openMenu();
      }

      return null;
    }
  }, {
    key: 'registerChild',
    value: function registerChild(childRef, childProps) {
      if ((0, _isChildRegistered2["default"])(childRef, this.activeChildren)) return;

      var _getChildMenuItemNode = (0, _utils.getChildMenuItemNodes)(this.containerRef.current),
          _getChildMenuItemNode2 = _toArray(_getChildMenuItemNode),
          nodes = _getChildMenuItemNode2.slice(0);

      this.activeChildren = (0, _utils.insertChildOrderly)(this.activeChildren, _extends({
        ref: childRef
      }, childProps), nodes);
    }
  }, {
    key: 'unregisterChild',
    value: function unregisterChild(childRef) {
      if (!(0, _isChildRegistered2["default"])(childRef, this.activeChildren)) return;
      this.activeChildren = this.activeChildren.filter(function (child) {
        return child.ref !== childRef;
      });
    }
  }, {
    key: 'hoverChild',
    value: function hoverChild(event, name) {
      this.setState({
        activeOptionName: name,
        activeOptionIndex: this.activeChildren.findIndex(function (child) {
          return child.name === name;
        })
      });
    }
  }, {
    key: 'openMenu',
    value: function openMenu() {
      var firstOptionIndex = this.activeChildren.length > 0 ? 0 : -1;
      var firstOptionName = this.activeChildren.length > 0 ? this.activeChildren[0].name : null;
      return this.setState({
        isOpen: true,
        activeOptionIndex: firstOptionIndex,
        activeOptionName: firstOptionName
      });
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      return this.setState({
        isOpen: false,
        activeOptionIndex: -1,
        activeOptionName: null
      });
    }
  }, {
    key: 'handleInputClick',
    value: function handleInputClick(event) {
      var onClick = this.props.onClick;
      var isOpen = this.state.isOpen;
      onClick(event);

      if (isOpen) {
        return this.closeMenu();
      }

      return this.openMenu();
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      var _props2 = this.props,
          onFocus = _props2.onFocus,
          value = _props2.value;
      var eventValue = value || null;
      onFocus(eventValue);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      var _props3 = this.props,
          onBlur = _props3.onBlur,
          value = _props3.value;
      this.closeMenu();
      var eventValue = value || null;
      onBlur(eventValue);
    }
  }, {
    key: 'handleOptionClick',
    value: function handleOptionClick(event, option) {
      var onChange = this.props.onChange;
      return onChange(option);
    }
  }, {
    key: 'scrollToOption',
    value: function scrollToOption(nextFocusedIndex) {
      var activeOptionIndex = this.state.activeOptionIndex;
      var currentFocusedOptionRef = this.activeChildren[activeOptionIndex].ref;
      var nextFocusedOptionRef = this.activeChildren[nextFocusedIndex].ref;

      if (!(0, _isOptionVisible2["default"])(nextFocusedOptionRef, this.menuRef.current)) {
        var amount = (0, _calculateScrollOffset2["default"])(currentFocusedOptionRef.offsetTop, nextFocusedOptionRef.offsetTop);
        this.scrollBy(amount);
      }
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(offset) {
      this.menuRef.current.scrollTo(0, offset);
    }
  }, {
    key: 'scrollBy',
    value: function scrollBy(offset) {
      this.menuRef.current.scrollBy(0, offset);
    }
  }, {
    key: 'updateScrollingArrows',
    value: function updateScrollingArrows() {
      var menu = this.menuRef.current;
      var showScrollUpArrow = menu.scrollTop > 0;
      var showScrollDownArrow = !(0, _isScrollPositionAtMenuBottom2["default"])(menu);
      this.setState({
        showScrollUpArrow: showScrollUpArrow,
        showScrollDownArrow: showScrollDownArrow
      });
    }
  }, {
    key: 'handleScrollUpArrowHover',
    value: function handleScrollUpArrowHover() {
      var _this2 = this;

      this.stopArrowScoll();
      var menu = this.menuRef.current;
      this.scrollingTimer = setInterval(function () {
        if (menu.scrollTop > 0) {
          menu.scrollBy(0, -1);
        } else {
          _this2.stopArrowScoll();
        }
      }, 5);
    }
  }, {
    key: 'handleScrollDownArrowHover',
    value: function handleScrollDownArrowHover() {
      var _this3 = this;

      this.stopArrowScoll();
      var menu = this.menuRef.current;
      this.scrollingTimer = setInterval(function () {
        if (!(0, _isScrollPositionAtMenuBottom2["default"])(menu)) {
          menu.scrollBy(0, 1);
        } else {
          _this3.stopArrowScoll();
        }
      }, 5);
    }
  }, {
    key: 'stopArrowScoll',
    value: function stopArrowScoll() {
      if (this.scrollingTimer) clearInterval(this.scrollingTimer);
    }
    /**
     * Sets focus on the element.
     * @public
     */

  }, {
    key: 'focus',
    value: function focus() {
      this.triggerRef.current.focus();
    }
    /**
     * Sets click on the element.
     * @public
     */

  }, {
    key: 'click',
    value: function click() {
      this.triggerRef.current.click();
    }
    /**
     * Sets blur on the element.
     * @public
     */

  }, {
    key: 'blur',
    value: function blur() {
      this.triggerRef.current.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          pickListLabel = _props4.label,
          hideLabel = _props4.hideLabel,
          style = _props4.style,
          error = _props4.error,
          title = _props4.title,
          assistiveText = _props4.assistiveText,
          isLoading = _props4.isLoading,
          disabled = _props4.disabled,
          readOnly = _props4.readOnly,
          required = _props4.required,
          children = _props4.children,
          id = _props4.id,
          tabIndex = _props4.tabIndex,
          placeholder = _props4.placeholder,
          name = _props4.name,
          valueInProps = _props4.value;
      var ariaLabel = title || assistiveText;

      var _getNormalizeValue3 = (0, _getNormalizeValue5["default"])(valueInProps),
          valueLabel = _getNormalizeValue3.label,
          icon = _getNormalizeValue3.icon;

      var value = valueLabel || '';
      var errorMessageId = this.getErrorMessageId();
      var menuContainerStyles = {
        maxHeight: this.getMenuMaxHeight()
      };
      var _state = this.state,
          showScrollUpArrow = _state.showScrollUpArrow,
          showScrollDownArrow = _state.showScrollDownArrow;
      return _react2["default"].createElement('div', {
        id: id,
        role: 'presentation',
        className: this.getContainerClassNames(),
        style: style,
        onKeyDown: this.handleKeyPressed,
        ref: this.containerRef
      }, _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: !!pickListLabel
      }, _react2["default"].createElement(_label2["default"], {
        label: pickListLabel,
        hideLabel: hideLabel,
        required: required,
        inputId: this.inputId,
        readOnly: readOnly
      })), _react2["default"].createElement('div', {
        className: 'rainbow-picklist_inner-container'
      }, _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: !!icon
      }, _react2["default"].createElement('span', {
        className: 'rainbow-picklist_icon'
      }, icon)), _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: !readOnly
      }, _react2["default"].createElement('span', {
        className: this.getIndicatorClassNames()
      })), _react2["default"].createElement('input', {
        className: this.getInputClassNames(),
        id: this.inputId,
        type: 'text',
        name: name,
        value: value,
        onClick: this.handleInputClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        placeholder: placeholder,
        tabIndex: tabIndex,
        readOnly: true,
        disabled: disabled,
        required: required,
        'aria-describedby': errorMessageId,
        autoComplete: 'off',
        ref: this.triggerRef
      }), _react2["default"].createElement('div', {
        role: 'listbox',
        className: this.getDropdownClassNames()
      }, _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: showScrollUpArrow
      }, _react2["default"].createElement(_menuArrowButton2["default"], {
        arrow: 'up',
        onMouseEnter: this.handleScrollUpArrowHover,
        onMouseLeave: this.stopArrowScoll
      })), _react2["default"].createElement('ul', {
        role: 'presentation',
        onScroll: this.updateScrollingArrows,
        'aria-label': ariaLabel,
        ref: this.menuRef,
        style: menuContainerStyles
      }, _react2["default"].createElement(_menuContent2["default"], {
        isLoading: isLoading
      }, _react2["default"].createElement(_context.Provider, {
        value: this.getContext()
      }, children))), _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: showScrollDownArrow
      }, _react2["default"].createElement(_menuArrowButton2["default"], {
        arrow: 'down',
        onMouseEnter: this.handleScrollDownArrowHover,
        onMouseLeave: this.stopArrowScoll
      })))), _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: !!error
      }, _react2["default"].createElement('div', {
        id: errorMessageId,
        className: 'rainbow-picklist_input-error'
      }, error)));
    }
  }]);

  return Picklist;
}(_react.Component);

Picklist.propTypes = {
  /** Text label for the PickList. */
  label: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node]).isRequired,

  /** A boolean to hide the PickList label. */
  hideLabel: _propTypes2["default"].bool,

  /** The content of the Picklist. Used to render the options
   * when the Picklist is open. */
  children: _propTypes2["default"].oneOfType([_propTypes2["default"].arrayOf(_propTypes2["default"].node), _propTypes2["default"].object]),

  /** If is set to true, then is showed a loading symbol. */
  isLoading: _propTypes2["default"].bool,

  /** Displays tooltip text when the mouse moves over the element. */
  title: _propTypes2["default"].string,

  /** A description for assistive sreen readers. */
  assistiveText: _propTypes2["default"].string,

  /** Specifies the selected value of the Picklist. */
  value: _propTypes2["default"].oneOfType([_propTypes2["default"].object, _propTypes2["default"].string]),

  /**  The action triggered when click/select an option. */
  onChange: _propTypes2["default"].func,

  /** The action triggered when the element is clicked. */
  onClick: _propTypes2["default"].func,

  /** The action triggered when the element receives focus. */
  onFocus: _propTypes2["default"].func,

  /** The action triggered when the element releases focus. */
  onBlur: _propTypes2["default"].func,

  /** Specifies the tab order of an element (when the tab button is used for navigating). */
  tabIndex: _propTypes2["default"].string,

  /** Text that is displayed when the field is empty, to prompt the user for a valid entry. */
  placeholder: _propTypes2["default"].string,

  /** The name of the Picklist. */
  name: _propTypes2["default"].string,

  /** Specifies that the Picklist must be filled out before submitting the form. */
  error: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node]),

  /** Specifies that an option must be selected before submitting the form.
   * This value defaults to false. */
  required: _propTypes2["default"].bool,

  /** Specifies that the Picklist element should be disabled. This value defaults to false. */
  disabled: _propTypes2["default"].bool,

  /** Specifies that the Picklist is read-only. This value defaults to false. */
  readOnly: _propTypes2["default"].bool,

  /** The id of the outer element. */
  id: _propTypes2["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2["default"].object
};
Picklist.defaultProps = {
  children: null,
  isLoading: false,
  title: undefined,
  assistiveText: undefined,
  value: undefined,
  onChange: function onChange() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  tabIndex: undefined,
  placeholder: undefined,
  name: undefined,
  hideLabel: false,
  id: undefined,
  error: null,
  disabled: false,
  readOnly: false,
  required: false,
  className: undefined,
  style: undefined
};
exports["default"] = (0, _withReduxForm2["default"])(Picklist);
exports.Component = Picklist;